import inDOM from 'dom-helpers/canUseDOM'
import { SERVER_ERROR_TYPE } from '../../actions'
import { getGlobalContentApiUrl } from '../../selectors'
import { fetchJson } from '../../api'

async function fetchServerErrorContent (store, error) {
  const api = getGlobalContentApiUrl(store.getState())
  const content = await fetchJson(api, 'error-page-500')
  return {
    error,
    content
  }
}

export default store => next => action => {
  if (!inDOM && action.type === SERVER_ERROR_TYPE) {
    action.payload = fetchServerErrorContent(store, action.payload)
  }
  return next(action)
}
